import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

export class RequestInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request to add the new header
    var _token = (sessionStorage["Token"]) ? sessionStorage["Token"]: "";
    
    const clonedRequest = req.clone({ headers: req.headers.set('Token', _token) });

    // Pass the cloned request instead of the original request to the next handle
    return next.handle(clonedRequest);
  }
}



// WEBPACK FOOTER //
// ./src/app/http-interceptor.ts